import { render, staticRenderFns } from "./TrackAndTraceColumnsCustom.vue?vue&type=template&id=5f89b812&scoped=true&"
import script from "./TrackAndTraceColumnsCustom.vue?vue&type=script&lang=js&"
export * from "./TrackAndTraceColumnsCustom.vue?vue&type=script&lang=js&"
import style0 from "./TrackAndTraceColumnsCustom.vue?vue&type=style&index=0&id=5f89b812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89b812",
  null
  
)

export default component.exports